var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "90%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("el-upload", {
        ref: "upload",
        staticStyle: { width: "50%" },
        attrs: {
          action: "",
          limit: 1,
          "http-request": _vm.uploadFile,
          "show-file-list": false,
        },
        scopedSlots: _vm._u([
          {
            key: "trigger",
            fn: function () {
              return [
                _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
                  _vm._v("选择上传文件"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("p", { staticStyle: { margin: "10px 0" } }, [
        _vm._v("下载导入模板: "),
        _c("span", { staticClass: "blue", on: { click: _vm.downloadFile } }, [
          _vm._v("门店模板.xlsx"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "ql-table",
          attrs: {
            data: _vm.tableData,
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold" },
            "row-key": "orderNo",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "storeName",
              label: "门店名称",
              "min-width": "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: "门店电话",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "province",
              label: "省",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "city",
              label: "市",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "district",
              label: "区",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              label: "详细地址",
              "min-width": "150",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "longitude",
              label: "经度",
              "min-width": "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "latitude",
              label: "纬度",
              "min-width": "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "openTime",
              label: "营业时间",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "原因",
              "min-width": "200",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(_vm._s(scope.row.reason)),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }